import React, { ReactNode } from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentCombine from "core/Components/ContentCombine";

type Props = {
    children: ReactNode,
};

const ItemDescription: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const style = css`
        margin-top: 48px;

        ${theme.breakpoints.between('lg', 'xl')} {
            margin-top: 37px;
        }

        ${theme.breakpoints.only('md')} {
            margin-top: 29px;
        }

        ${theme.breakpoints.only('sm')} {
            margin-top: 33px;
        }
        
        ${theme.breakpoints.down('xs')} {
            margin-top: 40px;
        }
        
    `;

    return (
        <div css={style}>
            <ContentCombine fontSizeType={'19'}>
                {children}
            </ContentCombine>
        </div>
    );
};

export default ItemDescription;